const NOTIFICATION = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export { NOTIFICATION };
